// Per-business cache of item names typed in CreateEstimate. Powers a <datalist>
// suggestion box so a returning user can pick "22K bridal necklace" with one
// tap instead of retyping. Pure client-side — no server cost. LRU-trimmed at 50.

const MAX_NAMES = 50;
const KEY_PREFIX = 'jcalc.itemNames.';

function key(businessId: string): string {
  return `${KEY_PREFIX}${businessId}`;
}

export function getItemNameSuggestions(businessId: string): string[] {
  if (!businessId) return [];
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(key(businessId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is string => typeof v === 'string' && v.length > 0);
  } catch {
    return [];
  }
}

export function rememberItemNames(businessId: string, names: ReadonlyArray<string>): void {
  if (!businessId) return;
  if (typeof localStorage === 'undefined') return;
  const cleaned = names.map((n) => n.trim()).filter((n) => n.length > 0 && n.length <= 120);
  if (cleaned.length === 0) return;
  const existing = getItemNameSuggestions(businessId);
  // Most-recent-first, dedupe case-insensitively but keep canonical casing of new entry.
  const merged: string[] = [];
  const seen = new Set<string>();
  for (const name of [...cleaned, ...existing]) {
    const k = name.toLowerCase();
    if (seen.has(k)) continue;
    seen.add(k);
    merged.push(name);
    if (merged.length >= MAX_NAMES) break;
  }
  try {
    localStorage.setItem(key(businessId), JSON.stringify(merged));
  } catch {
    // Quota or private-mode → silent. Suggestions are a nicety, not a contract.
  }
}
